"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function ONousIntervenons() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const portraits = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_cleaning_nozzle.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_cleaning_nozzle.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_cleaning_nozzle.png-wvc-sizes",
    alt: "Buse de nettoyage haute pression pour drain"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/camera_inspection_screen.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/camera_inspection_screen.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/camera_inspection_screen.png-wvc-sizes",
    alt: "Écran d'inspection caméra montrant l'intérieur d'un tuyau"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/technician_working_drain.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/technician_working_drain.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/technician_working_drain.png-wvc-sizes",
    alt: "Technicien OT Solution en intervention de débouchage"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_pipe_clog_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_pipe_clog_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_pipe_clog_detail.png-wvc-sizes",
    alt: "Détail technique d'un drain obstrué"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/service_truck_montreal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/service_truck_montreal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/service_truck_montreal.png-wvc-sizes",
    alt: "Camion de service OT Solution à Montréal"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/high_tech_drain_equipment.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/high_tech_drain_equipment.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/high_tech_drain_equipment.png-wvc-sizes",
    alt: "Équipement de pointe pour inspection de drains"
  }];
  return <section data-section-id="760" id="où-nous-intervenons" className="bg-background text-foreground relative min-h-[90vh] w-full overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-10 md:py-24 lg:px-14 lg:py-0 lg:min-h-[90vh] lg:flex lg:items-center">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-12 w-full">
          {}
          <div ref={leftRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase mb-10" style={{
            color: "var(--primary)"
          }}>
              <span style={{
              color: "var(--secondary)"
            }}>[01]</span>
              <span className="mx-2 text-muted-foreground">/</span>
              <span className="text-foreground">ZONES DE SERVICE</span>
            </div>

            {}
            <h1 className="font-default font-semibold text-foreground leading-[0.95] text-[44px] sm:text-[56px] md:text-[68px] lg:text-[72px] xl:text-[80px]" style={{
            letterSpacing: "-0.03em"
          }}>
              Expertise
              <br />
              Ciblée au
              <br />
              Grand Montréal
            </h1>

            {}
            <Separator className="my-10 bg-primary" style={{
            width: "64px",
            height: "2px"
          }} />

            {}
            <p className="font-default text-[17px] leading-[1.65] text-muted-foreground max-w-[480px]">
              OT Solution déploie ses unités mobiles spécialisées pour résoudre vos problèmes de drainage les plus complexes. Nous intervenons avec une précision chirurgicale pour le débouchage et l'inspection par caméra, garantissant une fluidité optimale de vos infrastructures souterraines à travers toute la métropole et ses couronnes.
            </p>

            {}
            <div className="mt-12 font-mono text-[12px] tracking-[0.2em] uppercase text-muted-foreground">
              <span className="text-foreground">5 Secteurs Clés</span>
              <span className="mx-3" style={{
              color: "var(--primary)"
            }}>
                /
              </span>
              <span className="text-foreground">Disponibilité 24/7</span>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 flex items-center transition-all duration-1200 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="grid w-full grid-cols-2 grid-rows-3 gap-2 lg:grid-cols-3 lg:grid-rows-2 lg:aspect-[3/2.1]">
              {portraits.map((portrait, i) => <div data-index={i} key={i} className="relative overflow-hidden bg-muted group rounded-md shadow-md" style={{
              transitionDelay: `${i * 80}ms`
            }}>
                  <img src={portrait.src} data-wvc-srcset={portrait.srcset} data-wvc-sizes={portrait.sizes} alt={portrait.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" style={{
                filter: "saturate(0.9) contrast(1.1) brightness(0.95)",
                aspectRatio: "1 / 1"
              }} />
                  {}
                  <div className="pointer-events-none absolute inset-0 mix-blend-multiply opacity-30" style={{
                background: "linear-gradient(135deg, hsla(217, 91%, 60%, 0.3), hsla(222, 47%, 4%, 0.5))"
              }} />
                  {}
                  <div className="absolute top-2 left-2 font-mono text-[10px] tracking-[0.2em] text-white mix-blend-normal bg-primary/80 px-1">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0">
        <Separator className="bg-border/40" />
      </div>
    </section>;
}